/* Generated by scripts/generate.ts from src/locales. Do not edit by hand. */
import { ActivityCopy, activitySchema } from "./activity";
import { CommitmentCopy, commitmentSchema } from "./commitment";
import { DealDetailsCopy, dealDetailsSchema } from "./deal-details";
import { EarningsHubCopy, earningsHubSchema } from "./earnings-hub";
import { FundOverviewCopy, fundOverviewSchema } from "./fund-overview";
import { HoldingCopy, holdingSchema } from "./holding";
import { HomeCopy, homeSchema } from "./home";
import { ReallocationCopy, reallocationSchema } from "./reallocation";
import { TransitionsCopy, transitionsSchema } from "./transitions";

export interface CopyTypes {
  "activity": ActivityCopy;
  "commitment": CommitmentCopy;
  "deal-details": DealDetailsCopy;
  "earnings-hub": EarningsHubCopy;
  "fund-overview": FundOverviewCopy;
  "holding": HoldingCopy;
  "home": HomeCopy;
  "reallocation": ReallocationCopy;
  "transitions": TransitionsCopy;
}

export type CopyNamespace = keyof CopyTypes;

export const COPY_SCHEMAS = {
  "activity": activitySchema,
  "commitment": commitmentSchema,
  "deal-details": dealDetailsSchema,
  "earnings-hub": earningsHubSchema,
  "fund-overview": fundOverviewSchema,
  "holding": holdingSchema,
  "home": homeSchema,
  "reallocation": reallocationSchema,
  "transitions": transitionsSchema,
} as const;
